import type { EditorCommand, ExtractInjectionAPI } from '@atlaskit/editor-common/types';

import type { MalleableUiPlugin } from '../malleableUiPluginType';
import type { MalleableUiPluginMeta } from '../pm-plugins/plugin-key';
import { malleableUiPluginKey } from '../pm-plugins/plugin-key';

// Internal command: the effect host is the only writer of this global machine projection.
export const setIsAnyRemixing =
	(
		api: ExtractInjectionAPI<MalleableUiPlugin> | undefined,
		isAnyRemixing: boolean,
	): EditorCommand =>
	({ tr }) => {
		if (api?.malleableUi?.sharedState?.currentState()?.isAnyRemixing === isAnyRemixing) {
			return null;
		}

		tr.setMeta(malleableUiPluginKey, {
			isAnyRemixing,
		} satisfies MalleableUiPluginMeta);
		return tr;
	};
